(function(){

  //function to load script
  //url is the url containing the script
  //callback is the function to execute after the script is loaded
  var loadScript = function(url, callback){
 
    var script = document.createElement("script");
    script.type = "text/javascript";

    //internet explorer
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    }
    //other browsers
    else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    //append to the head tag the script
    document.getElementsByTagName("head")[0].appendChild(script);
    
  };

  //code that I want to execute
  var myCode = function($){
    
    
    //----------------- ++ --------------------
    
      //alert("HTML: " + $(".product__price").html());
    //alert('---');


   //---------------------- prohibitedItems check cart page -------------------------------------
         //nz009
    var prohibitedItems = function(){
      
    	if($('.prohibited-popup').length>0){
        $('.prohibited-popup').on('click', function(){ 

          if($('#isOutsideShipping').length>0 && $('#isOutsideShipping').val() =='yes'){ 
              if($('.sc-modal-content-holder').length>0){
                 $('.sc-modal-content-holder .sc-model-content-alert-msg').html( $('#prohibited_popup_item_remove_message').html() );
                
                if($('#prohibited_products_list').length> 0){
                	$('.sc-modal-content-holder .sc-model-remove-content-msg').html( $('#prohibited_products_list').val().replace(/,\s*$/, "" ));
                }

                 $('.sc-btn-yes, .sc-btn-no').hide();
                 $('.sc-btn-ok').show();
              }
          }
          else{
              if($('.sc-modal-content-holder').length>0){
                 $('.sc-modal-content-holder .sc-model-content-alert-msg').html( $('#prohibited_popup_normal_message').html() );
                 $('.sc-modal-content-holder .sc-model-remove-content-msg').html('');
                 $('.sc-btn-yes, .sc-btn-no').show();
                 $('.sc-btn-ok').hide();
              }
          }

          $('#scCustomModal').show();
        });
      }

      if($('.sc-custom-close').length>0){
        $('.sc-custom-close, .sc-btn-ok').on('click', function(){
          $('#scCustomModal').hide();
        });
      }


      if($('.sc-btn-action').length>0){
        $('.sc-btn-action').on('click', function(){
          if($(this).data('target') == 'yes'){
              //$('#isOutsideShipping').val("yes");
              if($('.sc-modal-content-holder').length>0){
                  $('.sc-modal-content-holder .sc-model-content-alert-msg').html( $('#prohibited_popup_item_remove_message').html() );
                
                if($('#prohibited_products_list').length>0){	
                  $('.sc-modal-content-holder .sc-model-remove-content-msg').html( $('#prohibited_products_list').val().replace(/,\s*$/, "" ));
                }
                
                  $('.sc-btn-yes, .sc-btn-no').hide();
                  $('.sc-btn-ok').show();
              }
          }
          else if($(this).data('target') == 'no'){
            $('#scCustomModal').hide();
            location.href = $("#custom_return_to").val();
          }
        })
      }
    }
    
    prohibitedItems();
    
    //end nz009

  


    
    
    
    
    
    
    //------------------- ++ -------------------
   
  };

  //if we already have jQuery we simply execute our function
  //if jQuery is undefined we load the script using noConflict
  if (typeof jQuery === 'undefined'){
    loadScript('//code.jquery.com/jquery-1.12.4.js', function(){
      jQuery = jQuery.noConflict(true);
      myCode(jQuery);
    });
  } else {
    myCode(jQuery);
  }

})();